module.exports = __webpack_public_path__ + "static/media/Zim-Welcome-1.13a0f9ad.mp4";